import config from 'config/config';

export function getAssetUrl(key: string): string {
  return new URL(key, config.cdnUrl).toString();
}

interface ImageTransformerPayload {
  bucket: string;
  key: string;
  edits: {
    resize?: Partial<{
      width: number;
      height: number;
      fit: string;
      background: {
        r: number;
        g: number;
        b: number;
        alpha: number;
      };
    }>;
  };
}

export function getAssetTransformerUrl(
  key: string,
  options?: Partial<ImageTransformerPayload['edits']>
): string {
  const defaultResizeOptions = {
    fit: 'contain',
    background: {
      r: 0,
      g: 0,
      b: 0,
      alpha: 1,
    },
  };

  const payload: ImageTransformerPayload = {
    bucket: config.cdnBucket,
    key,
    edits: {
      resize: {
        ...defaultResizeOptions,
        ...(options?.resize || {}),
      },
    },
  };

  const encodedOptions = Buffer.from(JSON.stringify(payload)).toString('base64');

  return new URL(encodedOptions, config.imageTransformerUrl).toString();
}
